import { ColDef, GridReadyEvent, ICellRendererParams } from 'ag-grid-community'
import columnRenderers, { PLACEHOLDER } from 'components/column-renderers'
import InfinityAgGrid from 'components/table/InfinityAgGrid'
import React, { useMemo } from 'react'
import { CareArticleType, ETimelinePostType, ShareTimelineItem } from 'types'

export function SharedSentTable({ data }: { data: ShareTimelineItem[] }) {
  const handleGridReady = (event: GridReadyEvent) => {
    event.api.sizeColumnsToFit()
  }

  const columnDefs: ColDef[] = useMemo(() => {
    return [
      {
        headerName: 'Title',
        sortable: false,
        cellRenderer: (props: ICellRendererParams<ShareTimelineItem>) => {
          if (!props.data) return PLACEHOLDER

          const { type } = props.data
          if (type === ETimelinePostType.note) {
            return props.data.note?.subject || PLACEHOLDER
          }

          if (type === ETimelinePostType.careArticle || type === ETimelinePostType.taskArticle) {
            return props.data.careArticle?.post || props.data.careArticle?.name || PLACEHOLDER
          }

          if (type === ETimelinePostType.lessons) {
            return props.data.lesson?.post || props.data.lesson?.name || PLACEHOLDER
          }

          if (type === ETimelinePostType.learnArticles) {
            return props.data.learnArticle?.post || props.data.learnArticle?.name || PLACEHOLDER
          }

          return PLACEHOLDER
        },
      },
      {
        headerName: 'Type',
        field: 'type',
        cellRenderer: (props: ICellRendererParams<ShareTimelineItem>): string => {
          if (!props.data) return PLACEHOLDER

          const { type, careArticle } = props.data
          if (type === ETimelinePostType.note) {
            return 'Note'
          }

          if (
            careArticle &&
            (type === ETimelinePostType.careArticle || type === ETimelinePostType.taskArticle)
          ) {
            const careArticleType = careArticle.type
            if (careArticleType === CareArticleType.Care) {
              return 'Guide Post'
            }
            return 'Action Post'
          }

          if (type === ETimelinePostType.lessons) {
            return 'Lesson'
          }

          if (type === ETimelinePostType.learnArticles) {
            return 'Learn Article'
          }

          return PLACEHOLDER
        },
      },
      {
        headerName: 'Shared With',
        sortable: false,
        minWidth: 400,
        cellRenderer: (props: ICellRendererParams<ShareTimelineItem>): string => {
          if (!props.data) return PLACEHOLDER

          const { user } = props.data
          return `${user.firstname} ${user.lastname} / ${user.email}`
        },
      },
      {
        headerName: 'Comment',
        field: 'comment',
      },
      {
        headerName: 'Date',
        cellRenderer: columnRenderers.createdAt,
        colId: 'createdAt',
      },
    ]
  }, [])

  return (
    <div className="ag-theme-alpine" style={{ fontSize: '1rem' }}>
      <InfinityAgGrid
        rowData={data}
        columnDefs={columnDefs}
        rowModelType="clientSide"
        onGridReady={handleGridReady}
        floatingFiltersHeight={0}
        domLayout="autoHeight"
      />
    </div>
  )
}
